// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LJr1","rootMobile":"styles_rootMobile__RbIRO"};